import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useFilterDrawerReorderExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.FilterDrawerReorder,
        AmplitudeVariants.FilterDrawerReorder.Treatment
    );
